import * as React from 'react';
import { FooterComponent as FooterSection } from '@codeparva/gatsby-theme-layout-components';
import { footerConfig as footerData } from './config';
import { FacilityContext } from '../../contexts/facilityContext';
import { LayoutContext } from '../../contexts/layoutContext';
import { LocationsContext } from '../../contexts/locationsContext';
import { transformedFooterConfig } from './transformer';

export const Footer = () => {
  const facilityDetails = React.useContext(FacilityContext);
  const locationDetails = React.useContext(LocationsContext);
  const layoutDetails = React.useContext(LayoutContext);
  const { footerConfig, topbarConfig } = layoutDetails;
  const transformedFooterData = transformedFooterConfig(
    footerData,
    footerConfig,
    topbarConfig,
    locationDetails,
    facilityDetails,
  );
  return (
    <div data-testid="layout-footer">
      <FooterSection {...transformedFooterData} variant="esim-type" />
    </div>
  );
};
